import React from 'react';
import { Menu } from 'lucide-react';
// 1. Importe o Link
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
    return (
        <header className="sticky top-0 z-50 flex justify-center border-b border-white/10 bg-[#f6f7f8]/[.85] dark:bg-[#101922]/[.85] backdrop-blur-sm">
            <div className="flex w-full max-w-7xl items-center justify-between px-6 py-3">
                <div className="flex items-center gap-4 text-slate-800 dark:text-white">
                    <div className="size-6 text-[#137fec]">
                        {/* Seu SVG mantido aqui... */}
                    </div>
                    {/* 2. Troque href por to e use Link */}
                    <Link to="/" className="text-xl font-bold">Quantto</Link>
                </div>
                <div className="hidden items-center gap-8 md:flex">
                    <nav className="flex items-center gap-6">
                        {/* 3. Troque todos os links da navegação */}
                        <Link className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#137fec] dark:hover:text-[#137fec]" to="/recursos">Recursos</Link>
                        <Link className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#137fec] dark:hover:text-[#137fec]" to="/servicos">Serviços</Link>
                        <Link className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#137fec] dark:hover:text-[#137fec]" to="/precos">Preços</Link>
                        <Link className="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#137fec] dark:hover:text-[#137fec]" to="/contato">Contato</Link>
                    </nav>
                    <div className="flex gap-2">
                        {/* 4. Botões de Login e Cadastro também com Link */}
                        <Link to="/login" className="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-slate-200 dark:bg-white/10 text-slate-700 dark:text-white text-sm font-bold hover:bg-slate-300 dark:hover:bg-white/20">
                            <span className="truncate">Login</span>
                        </Link>
                        <Link to="/cadastro" className="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-[#137fec] text-white text-sm font-bold hover:bg-[#137fec]/90">
                            <span className="truncate">Cadastro</span>
                        </Link>
                    </div>
                </div>
                <button className="md:hidden text-slate-800 dark:text-white">
                    <Menu className="text-3xl" />
                </button>
            </div>
        </header>
    );
};

export default Navbar;